import { render } from "./ContentBlockItem.vue?vue&type=template&id=2076c4fd&scoped=true"
import script from "./ContentBlockItem.vue?vue&type=script&lang=js"
export * from "./ContentBlockItem.vue?vue&type=script&lang=js"

import "./ContentBlockItem.vue?vue&type=style&index=0&id=2076c4fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2076c4fd"]])

export default __exports__